export const BarcodeSideEnum = {
  FRONT: "FRONT",
  BACK: "BACK",
  NONE: "NONE",
};
